// Configurazione API centralizzata
export const API_CONFIG = {
    // URL base dell'API Elite Fitness
    BASE_URL: 'https://api.elitefitness.it',
    
    // Endpoint per l'autocompletamento
    ENDPOINTS: {
        LOCATION: {
            CITIES: '/api/open/location/cities',
            ADDRESSES: '/api/open/location/addresses',
            DETAILS: '/api/open/location/details',
            VALIDATE_POSTAL_CODE: '/api/open/location/validate-postal-code',
            HEALTH: '/api/open/location/health',
            TEST_API: '/api/open/location/test-api'
        }
    }
};

// Helper per costruire URL completi
export const buildApiUrl = (endpoint) => {
    return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper per chiamate API
export const apiCall = async (endpoint, options = {}) => {
    const url = buildApiUrl(endpoint);
    const response = await fetch(url, {
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        },
        ...options
    });
    
    if (!response.ok) {
        throw new Error(`API call failed: ${response.status} ${response.statusText}`);
    }
    
    return response.json();
};

// Servizi specifici per l'autocompletamento
export const locationService = {
    async searchCities(query) {
        return apiCall(`${API_CONFIG.ENDPOINTS.LOCATION.CITIES}?query=${encodeURIComponent(query)}`);
    },
    
    async searchAddresses(query) {
        return apiCall(`${API_CONFIG.ENDPOINTS.LOCATION.ADDRESSES}?query=${encodeURIComponent(query)}`);
    },
    
    async getLocationDetails(placeId) {
        return apiCall(`${API_CONFIG.ENDPOINTS.LOCATION.DETAILS}?place_id=${encodeURIComponent(placeId)}`);
    },
    
    async validatePostalCode(postalCode, city) {
        return apiCall(`${API_CONFIG.ENDPOINTS.LOCATION.VALIDATE_POSTAL_CODE}?postal_code=${postalCode}&city=${encodeURIComponent(city)}`);
    },
    
    async healthCheck() {
        return apiCall(API_CONFIG.ENDPOINTS.LOCATION.HEALTH);
    },
    
    async testApi() {
        return apiCall(API_CONFIG.ENDPOINTS.LOCATION.TEST_API);
    }
};
